export const Direction = {
    HORIZONTAL: 'HORIZONTAL',
    VERTICAL: 'VERTICAL',
};

export const TRANSITION_DURATION = 300;

export const queue = (fn, wait=TRANSITION_DURATION * 4) => {
    const fnQueue = [];
    let isWaiting;

    const execute = (params) => {
        isWaiting = true;
        fn(...params);
        setTimeout(resume, wait);
    };

    const resume = () => {
        isWaiting = false;
        if (fnQueue.length) {
            const params = fnQueue.shift();
            execute(params);
        }
    };

    return (...params) => {
        if (isWaiting) {
            fnQueue.push(params);
        } else {
            execute(params);
        }
    };
};

export const delay = (fn, duration=1) => setTimeout(fn, duration);

export const hideAppLayer = () => {
    const appLayer = document.getElementById('app_layer_wrapper');
    if (appLayer) {
        appLayer.classList.add('odf-hidden');
    }
};

export const getNextSlide = (slides, active) => {
    if (!active) return null;

    const { id } = slides.get(active);
    return [...slides.values()]
        .filter((slide) => !slide.isDone)
        .filter((slide) => slide.id !== id)
        .shift();
};
